import React from 'react';
import { Package, Gift } from 'lucide-react';
import { useLang } from '../LanguageContext';

const Formats = () => {
  const { t } = useLang();

  const formats = [
    { icon: Gift, label: t.formats.l1, title: t.formats.t1n, text: t.formats.d1 },
    { icon: Package, label: t.formats.l2, title: t.formats.t2n, text: t.formats.d2 }
  ];

  return (
    <section className="bg-[#0d1b36] py-28 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: 'radial-gradient(#d4a94c 1px, transparent 1px)',
          backgroundSize: '28px 28px'
        }}
      />
      <div className="relative max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6">
            {t.formats.eyebrow}
          </p>
          <h2 className="font-serif text-5xl md:text-6xl text-[#f6ecd9] leading-[1.08]">
            {t.formats.t1}<br />
            <em className="italic font-light">{t.formats.t2}</em>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div
              className="absolute -inset-6 rounded-3xl blur-3xl opacity-30"
              style={{
                background: 'radial-gradient(circle at 50% 50%, #d4a94c 0%, transparent 70%)'
              }}
            />
            <img
              src="https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/uye6halt_BOITE.png"
              alt="Boîtes Murat — petite & grande"
              className="relative w-full h-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-700"
            />
          </div>

          <div className="space-y-6">
            {formats.map((f, i) => (
              <div
                key={i}
                className="group relative p-8 rounded-2xl border border-[#d4a94c]/20 bg-[#f6ecd9]/[0.03] hover:border-[#d4a94c]/60 hover:bg-[#f6ecd9]/[0.06] transition-all duration-500 cursor-pointer"
              >
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full border border-[#d4a94c]/50 flex items-center justify-center group-hover:bg-[#d4a94c] transition-all duration-500">
                    <f.icon className="w-6 h-6 text-[#d4a94c] group-hover:text-[#0d1b36] transition-colors" strokeWidth={1.5} />
                  </div>
                  <div className="flex-1">
                    <p className="text-[10px] tracking-[0.35em] uppercase text-[#d4a94c] mb-2">
                      {f.label}
                    </p>
                    <h3 className="font-serif text-3xl text-[#f6ecd9] mb-3">{f.title}</h3>
                    <p className="text-[#f6ecd9]/70 leading-relaxed text-sm">{f.text}</p>
                  </div>
                </div>
              </div>
            ))}

            <div className="flex flex-wrap gap-2 pt-2">
              <span className="px-3 py-1.5 rounded-full border border-[#f6ecd9]/20 text-[#f6ecd9]/70 text-[10px] tracking-[0.25em] uppercase">
                Fabrication française
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Formats;
